import getUserLocationPromise from 'helpers/getUserLocationPromise';
import { observable } from 'mobx';

import MobxState from './abstract/MobxState';

class UserLocationState extends MobxState {
  state = null;

  error = null;

  init() {}

  destroy() {}

  *getLocation(force) {
    if (force || !this.state) {
      try {
        this.state = yield getUserLocationPromise();
      } catch (e) {
        this.error = e.message;
      }
    }

    return this.state;
  }
}

UserLocationState.annotations = {
  ...MobxState.annotations,
  state: observable.ref,
  error: observable.ref,
};

export default UserLocationState;
